import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { breadcrumbs, setLoading } from "../../../../actions/appActions";
import { push } from "react-router-redux";
import loginInfo from "../../components/LoginInfo";
import { getFunctionaryNoticeTypes, toggleActivateTemplate, getBaselineTemplate } from "../../CroActions";
import { dictToOptions } from "../../CroUtils";
import Button from "../../../../components/form/Button";

import { EmailTemplatesType } from "../../enum";
import {
    TemplatesEmailDefault,
    TemplatesEmailAppeals
} from "../../components/grids/EmailTemplatesGrid";

class EmailTemplates extends Component {
  state = {
    selectedType: null,
    functionaryNoticeTypeOptions: [],
    loading: true,
    baselineContent: null,
    baselineOpen: false,
  };

  async componentDidMount() {
    const { dispatch } = this.props;

    this.props.breadcrumbs([{ label: "Šablony" }]);

    dispatch(setLoading(true, "Načítání dat..."));
    const noticeTypes = await getFunctionaryNoticeTypes(dispatch);
    this.setState({
      selectedType: EmailTemplatesType[0].id,
      functionaryNoticeTypeOptions: dictToOptions(noticeTypes.items),
      loading: false,
    });
    await this.loadBaseline(EmailTemplatesType[0].id);
    dispatch(setLoading());
  }

  loadBaseline = async (typeId) => {
    const content = await this.props.dispatch(getBaselineTemplate(typeId));
    this.setState({ baselineContent: content });
  };

  getActiveType() {
    return EmailTemplatesType.find((type) => type.id === this.state.selectedType);
  }

  isActiveTypeAppeals() {
    return this.getActiveType()?.id === EmailTemplatesType.find((type) => type.id === "APPEAL_CREATE")?.id;
  }

  onTypeClick = (type) => async () => {
    this.setState({ selectedType: type.id, baselineContent: null });
    await this.loadBaseline(type.id);
  }

  onAdd = () => {
    const activeType = this.getActiveType();
    this.props.push(`/administrator/sablony/email/form?type=${activeType.id}`);
  }

  onShowBaseline = () => this.setState({ baselineOpen: true });
  onCloseBaseline = () => this.setState({ baselineOpen: false });

  onOpenDetail = ({ id }) => {
    this.props.push(`/administrator/sablony/email/form/${id}`);
  };  
  
  onDeactivateTemplate = async ({ id, type }) => {
    await this.props.dispatch(toggleActivateTemplate(id, false));
    this.reloadGrid();
  }

  onActivateTemplate = async ({ id, type }) => {
    await this.props.dispatch(toggleActivateTemplate(id, true));
    this.reloadGrid();
  }

  reloadGrid = () => {
    const activeType = this.getActiveType();
    this.setState({ selectedType: null });
    this.setState({ selectedType: activeType.id });
  }

  render() {
    const { loading } = this.state;
    if (loading) {
      return <></>;
    }

    const activeType = this.getActiveType();


    const ApiUrl = '/spravce/api/sablony';
    const GridComponent = this.isActiveTypeAppeals()
                                ? TemplatesEmailAppeals
                                : TemplatesEmailDefault;

    return (
      <div className="emailTemplatesPage">
        <div className="pageTabs pageTabs--templates">
          <div className="pageTabs__scroller">
            {EmailTemplatesType.map((type) => (
              <button
                key={type.id}
                type="button"
                className={
                  activeType && activeType.id === type.id ? "pageTabs__tab pageTabs__tab--active" : "pageTabs__tab"
                }
                onClick={this.onTypeClick(type)}
              >
                {type.label}
              </button>
            ))}
          </div>
        </div>
        {activeType && (
          <>
            {this.state.baselineContent && (
              <div style={{ marginBottom: 8 }}>
                <Button label="Zobrazit původní šablonu" onClick={this.onShowBaseline} />
              </div>
            )}
            <GridComponent
              {...this.props}
              url={ApiUrl}
              query={{ type: activeType.id }}
              gridName={`emailTemplatesGrid_${activeType.id}`}
              adding={true}
              onAdd={this.onAdd}
              onRowClick={this.onOpenDetail}
              onActivateTemplate={this.onActivateTemplate}
              onDeactivateTemplate={this.onDeactivateTemplate}
              {...(this.isActiveTypeAppeals() && { functionaryNoticeTypeOptions: this.state.functionaryNoticeTypeOptions })}
            />
            <Dialog open={this.state.baselineOpen} onClose={this.onCloseBaseline} maxWidth="md" fullWidth>
              <DialogTitle>{`Původní šablona — ${activeType.label}`}</DialogTitle>
              <DialogContent>
                <div
                  className="baselineTemplatePreview"
                  dangerouslySetInnerHTML={{ __html: this.state.baselineContent }}
                />
              </DialogContent>
              <DialogActions>
                <Button label="Zavřít" onClick={this.onCloseBaseline} />
              </DialogActions>
            </Dialog>
          </>
        )}
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, push })(loginInfo(EmailTemplates));
